<div class="welcome-screen">
  <div class="welcome-card">
    <img class="welcome-logo" src="/assets/img/hsbooster.svg" alt="HSbooster"/>
    <h1 class="welcome-title">Standard Operating Procedures management platform</h1>
    <p class="welcome-subtitle">Please select a section in the sidebar to get started.</p>
  </div>
</div>
